import { Col, Row, Table } from "antd";
import { ColumnsType } from "antd/es/table/interface";
import CodeSyntaxHighlighter from "../../../component/syntax-highlighter";

interface DataType {
  attribute: React.Key;
  value: string;
  default: number;
  description: string;
}

const dataSource = [
  {
    attribute: "collections (required)",
    value: "your-collections-name",
    default: "None",
    description:
      "Set your collection name so the API knows which collection to send to the embed. Example: bcbrawlers,crptomonkeys,dc.funko.",
  },
  {
    attribute: "itemperpages",
    value: "number between 1 and 100",
    default: 12,
    description:
      "Set a value on how the maximum amount of NFT's to show per page",
  },
  {
    attribute: "isshowfilter",
    value: "true/false",
    default: "true",
    description: "To display filter or not",
  },
  {
    attribute: "network",
    value: "Supported chains/networks",
    default: "mainnet",
    description:
      "Mainnet is the default network you can set it to testnet if you want to try it out first.",
  },
  {
    attribute: "redirect",
    value: "None",
    default: "None",
    description:
      "The redirect URL is optional and is a way for you to interact with a transaction that happened see the redirect URL, default behavior is to redirect the user back to the URL it came from with no extra params.",
  },
];

const columns = [
  {
    title: "Attribute",
    dataIndex: "attribute",
    key: "attribute",
    render: (text: any) => <p className="w-font-md color-primary">{text}</p>,
  },
  {
    title: "Value",
    dataIndex: "value",
    key: "value",
    render: (text: any) => <p className="w-font-md color-text-secondary">{text}</p>,

  },
  {
    title: "Default",
    dataIndex: "default",
    key: "default",
    render: (text: any) => <p className="w-font-md color-text-secondary">{text}</p>,

  },

  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    render: (text: any) => <p className="w-font-md color-text-secondary">{text}</p>,

  },
];

export default function Option() {
  var html =
    '<wax-marketplace collections="your-collections-name" itemsperpage="12"> </wax-marketplace>';
  return (
    <Row gutter={[0, 40]}>
      <Col xs={24}>
        <h1>Options</h1>
      </Col>
      <Col xs={24}>
        <Row gutter={[0, 40]}>
          <Col xs={24}>
            <Row gutter={[0, 16]}>
              <Col xs={24}>
                <p className="w-font-md fw-600 color-text-secondary">
                  Options have placed the element as attributes with a value.
                  which looks as follows:
                </p>
              </Col>
              <Col xs={24}>
                <CodeSyntaxHighlighter code={html} />
              </Col>
              <Col xs={24}>
                <p className="w-font-md fw-600 color-text-secondary">
                  Most attributes are optional except for the collections
                </p>
              </Col>
            </Row>
          </Col>
          <Col className="w-font-md fw-600" xs={24} style={{overflow:'auto'}}>
            <Table
              pagination={false}
              dataSource={dataSource}
              columns={columns}
            />
          </Col>
          <Col className="w-font-md fw-600" xs={24}>
            <Row gutter={[0, 16]}>
              <Col xs={24}>
                <h4 className="w-font-md">Redirect URL</h4>
              </Col>
              <Col className="color-text-secondary" xs={24}>
                <p className="w-font-md">
                  If a redirect URL is placed as an attribute after the user has
                  signed the transaction, the user will be redirected to the
                  redirect URL after the transaction has been completed. we will
                  include a couple of attributes in the query string to help you
                  with the process
                </p>

                <ul className="w-font-md" style={{ marginLeft: 16 }}>
                  <li>tx: the transaction hash</li>
                  <li>
                    status: the status of the transaction (executed or failed)
                    this still needs to be validated as a successfully executed
                  </li>
                  <li>sale: the sale id</li>
                  <li>assets: the asset ids as "12345,12345,12345"</li>
                </ul>
              </Col>
              <Col className="w-font-md color-text-secondary" xs={24}>
                <p>
                  while we provide some useful data it's still up to you to
                  validate that the transaction is valid and the user did make
                  the sale. Everybody can write to a URL so be careful.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
